'use client'

import {useRouter} from "next/navigation";
import {useEffect, useState} from "react";

export const useLoading = () => {
  const router = useRouter()
  const [isLoading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    const handleStart = (url: string) => {
      console.log(`page start loading: ${url}`)
      setLoading(true)
    }

    const handleStop = () => {
      console.log(`page loaded!`)
      setLoading(false)
    }

    // router.events.on('routeChangeStart', handleStart)
    // router.events.on('routeChangeComplete', handleStop)
    // router.events.on('routeChangeError', handleStop)

    // return () => {
    //     router.events.off('routeChangeStart', handleStart)
    //     router.events.off('routeChangeComplete', handleStop)
    //     router.events.off('routeChangeError', handleStop)
    // }
  }, [router])

  return {
    isLoading
  }
}